import { ObservationConditionType } from "generated/graphql";
import {
  observationConditionLabelDotColorMap,
  observationConditionLabelMap,
} from "src/utils/label-maps/observation-condition";
import { twMerge } from "tailwind-merge";

export const ObservationConditionRating = ({
  condition,
}: { condition: ObservationConditionType }) => {
  const circles = Array.from({ length: 3 }).fill(null);
  const conditionOrder = Object.keys(
    observationConditionLabelMap,
  ) as Array<ObservationConditionType>;
  const conditionIndex = 3 - conditionOrder.indexOf(condition);

  return (
    <div className="flex items-center gap-2">
      <div className="flex gap-[3px]">
        {circles.map((_, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={twMerge(
              "h-[5px] w-[5px] rounded-full",
              index <= conditionIndex &&
                condition !== ObservationConditionType.Dead
                ? observationConditionLabelDotColorMap[condition]
                : "border border-grey-200",
            )}
          />
        ))}
      </div>
    </div>
  );
};
